import { Injectable, inject } from '@angular/core';
import { State, Selector, Action, StateContext } from '@ngxs/store';
import { Observable, finalize, tap } from 'rxjs';
import { INewsItem } from '../../interfaces/news/INews';
import { NewsService } from '../../services/news.service';
import { LoadAllActiveNews, CreateNews } from './news.actions';

export interface INewsStateModel {
  activeNewsList: INewsItem[];
  isLoading: boolean;
}

@State<INewsStateModel>({
  name: 'newsState',
  defaults: {
    activeNewsList: [],
    isLoading: false,
  },
})
@Injectable()
export class NewsState {
  private readonly newsService = inject(NewsService);

  @Selector()
  static activeNewsList(state: INewsStateModel): INewsItem[] {
    return state.activeNewsList;
  }

  @Selector()
  static isLoading(state: INewsStateModel): boolean {
    return state.isLoading;
  }

  @Action(LoadAllActiveNews)
  loadAllActiveNews(ctx: StateContext<INewsStateModel>): Observable<INewsItem[]> {
    this.setIsLoading(ctx, true);
    return this.newsService.getAllActiveNews().pipe(
      tap(activeNewsList => ctx.patchState({ activeNewsList })),
      finalize(() => this.setIsLoading(ctx, false)),
    );
  }

  @Action(CreateNews)
  createNews(ctx: StateContext<INewsStateModel>, { news }: CreateNews): Observable<INewsItem> {
    this.setIsLoading(ctx, true);
    return this.newsService.createNews(news).pipe(finalize(() => this.setIsLoading(ctx, false)));
  }

  private setIsLoading(ctx: StateContext<INewsStateModel>, isLoading: boolean): void {
    ctx.patchState({ isLoading });
  }
}
